import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Settings\ByokKeysController::edit
* @see app/Http/Controllers/Settings/ByokKeysController.php:28
* @route '/settings/byok-keys'
*/
export const edit = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(options),
    method: 'get',
})

edit.definition = {
    methods: ["get","head"],
    url: '/settings/byok-keys',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Settings\ByokKeysController::edit
* @see app/Http/Controllers/Settings/ByokKeysController.php:28
* @route '/settings/byok-keys'
*/
edit.url = (options?: RouteQueryOptions) => {
    return edit.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Settings\ByokKeysController::edit
* @see app/Http/Controllers/Settings/ByokKeysController.php:28
* @route '/settings/byok-keys'
*/
edit.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Settings\ByokKeysController::edit
* @see app/Http/Controllers/Settings/ByokKeysController.php:28
* @route '/settings/byok-keys'
*/
edit.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: edit.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Settings\ByokKeysController::edit
* @see app/Http/Controllers/Settings/ByokKeysController.php:28
* @route '/settings/byok-keys'
*/
const editForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Settings\ByokKeysController::edit
* @see app/Http/Controllers/Settings/ByokKeysController.php:28
* @route '/settings/byok-keys'
*/
editForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Settings\ByokKeysController::edit
* @see app/Http/Controllers/Settings/ByokKeysController.php:28
* @route '/settings/byok-keys'
*/
editForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

edit.form = editForm

/**
* @see \App\Http\Controllers\Settings\ByokKeysController::update
* @see app/Http/Controllers/Settings/ByokKeysController.php:62
* @route '/settings/byok-keys'
*/
export const update = (options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(options),
    method: 'patch',
})

update.definition = {
    methods: ["patch"],
    url: '/settings/byok-keys',
} satisfies RouteDefinition<["patch"]>

/**
* @see \App\Http\Controllers\Settings\ByokKeysController::update
* @see app/Http/Controllers/Settings/ByokKeysController.php:62
* @route '/settings/byok-keys'
*/
update.url = (options?: RouteQueryOptions) => {
    return update.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Settings\ByokKeysController::update
* @see app/Http/Controllers/Settings/ByokKeysController.php:62
* @route '/settings/byok-keys'
*/
update.patch = (options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(options),
    method: 'patch',
})

/**
* @see \App\Http\Controllers\Settings\ByokKeysController::update
* @see app/Http/Controllers/Settings/ByokKeysController.php:62
* @route '/settings/byok-keys'
*/
const updateForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Settings\ByokKeysController::update
* @see app/Http/Controllers/Settings/ByokKeysController.php:62
* @route '/settings/byok-keys'
*/
updateForm.patch = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

update.form = updateForm

/**
* @see \App\Http\Controllers\Settings\ByokKeysController::clear
* @see app/Http/Controllers/Settings/ByokKeysController.php:103
* @route '/settings/byok-keys/{provider}'
*/
export const clear = (args: { provider: string | number } | [provider: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: clear.url(args, options),
    method: 'delete',
})

clear.definition = {
    methods: ["delete"],
    url: '/settings/byok-keys/{provider}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Settings\ByokKeysController::clear
* @see app/Http/Controllers/Settings/ByokKeysController.php:103
* @route '/settings/byok-keys/{provider}'
*/
clear.url = (args: { provider: string | number } | [provider: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { provider: args }
    }

    if (Array.isArray(args)) {
        args = {
            provider: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        provider: args.provider,
    }

    return clear.definition.url
            .replace('{provider}', parsedArgs.provider.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Settings\ByokKeysController::clear
* @see app/Http/Controllers/Settings/ByokKeysController.php:103
* @route '/settings/byok-keys/{provider}'
*/
clear.delete = (args: { provider: string | number } | [provider: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: clear.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Settings\ByokKeysController::clear
* @see app/Http/Controllers/Settings/ByokKeysController.php:103
* @route '/settings/byok-keys/{provider}'
*/
const clearForm = (args: { provider: string | number } | [provider: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: clear.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Settings\ByokKeysController::clear
* @see app/Http/Controllers/Settings/ByokKeysController.php:103
* @route '/settings/byok-keys/{provider}'
*/
clearForm.delete = (args: { provider: string | number } | [provider: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: clear.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

clear.form = clearForm

const byokKeys = {
    edit: Object.assign(edit, edit),
    update: Object.assign(update, update),
    clear: Object.assign(clear, clear),
}

export default byokKeys